import {
  Box,
  Button,
  Chip,
  Stack,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import GlobalWrapper from "../../../../components/Wrapper/GlobalWrapper";
import { DataGrid } from "@mui/x-data-grid";
import CustomGridToolbar from "../../../../components/datagrid/GridToolBar";
import { useDispatch, useSelector } from "react-redux";
import { getAllUsers } from "../../../../redux/features/foodSlice";
import {
  revertStatus,
  verifyPayment,
} from "../../../../redux/features/trasportationSlice";
import { useSnackbar } from "notistack";
import { Icon } from "@iconify/react";
import VerifyPayment from "./VerifyPayment";

//STATUS IS DERIVED THE SAME WAY THE ROW CHIP DERIVES IT ( 0 = NOT VERIFIED , ANYTHING
//ELSE = VERIFIED ) SO THE FILTER AND THE BADGE CAN NEVER DISAGREE
const isVerified = (user) => user?.transport_payment_verification != 0;

const STATUS_FILTERS = [
  { id: "all", label: "All" },
  { id: "verified", label: "Verified" },
  { id: "not_verified", label: "Not Verified" },
];

const TransportVerification = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading, users } = useSelector((state) => state.food);

  useEffect(() => {
    dispatch(getAllUsers());
  }, []);
  const [gridSize, setGridSize] = useState(10);
  const [selectedIds, setSelectedIds] = useState([]);
  const [statusFilter, setStatusFilter] = useState("all");

  const userList = useMemo(() => (Array.isArray(users) ? users : []), [users]);

  const counts = useMemo(() => {
    const verified = userList.filter(isVerified).length;
    return { all: userList.length, verified, not_verified: userList.length - verified };
  }, [userList]);

  const filteredUsers = useMemo(() => {
    if (statusFilter === "verified") return userList.filter(isVerified);
    if (statusFilter === "not_verified") return userList.filter((user) => !isVerified(user));
    return userList;
  }, [userList, statusFilter]);

  const handleStatusFilterChange = (event, value) => {
    if (value === null) return; //KEEPS ONE OPTION ALWAYS SELECTED
    setStatusFilter(value);
    //ROWS LEAVING THE VIEW MUST NOT STAY SELECTED , OR A BULK VERIFY WOULD HIT HIDDEN USERS
    setSelectedIds([]);
  };

  const renderStatusCell = (params) => {
    return (
      <Chip
        size="small"
        variant="outlined"
        icon={
          params.row.transport_payment_verification == 0 ? (
            <Icon icon="radix-icons:cross-2" width="15" height="15" />
          ) : (
            <Icon
              icon="material-symbols:verified-outline-rounded"
              width="18"
              height="18"
            />
          )
        }
        color={
          params.row.transport_payment_verification == 0 ? "error" : "success"
        }
        label={
          params.row.transport_payment_verification == 0
            ? "Not Verified"
            : "Verified"
        }
      />
    );
  };

  const renderVerifyButton = (params) => {
    return (
      <Box>
        {params.row.transport_payment_verification == 0 ? (
          <VerifyPayment params={params} />
        ) : (
          <Button
            size="small"
            onClick={() => {
              dispatch(revertStatus(params.row.userID)).then((res) => {
                if (res.payload.status === "success") {
                  enqueueSnackbar(res.payload.message, { variant: "success" });
                  dispatch(getAllUsers());
                } else if (res.payload.status === "failed") {
                  enqueueSnackbar(res.payload.message, { variant: "error" });
                }
              });
            }}
          >
            Revert
          </Button>
        )}
      </Box>
    );
  };
  const TableHead = [
    {
      field: "userID",
      headerName: "SlNo",
      width: 60,
    },
    {
      field: "name",
      headerName: "name",
      width: 250,
    },
    {
      field: "transport_payment_verification",
      headerName: "Status",
      width: 160,
      renderCell: renderStatusCell,
    },
    {
      field: "Verify",
      headerName: "Verify",
      width: 160,
      renderCell: renderVerifyButton,
    },
  ];
  return (
    <GlobalWrapper
      title={"Transport Verification"}
      actions={
        <>
          {selectedIds.length >= 2 ? (
            <VerifyPayment
              bulk={true}
              params={selectedIds}
              setSelectedIds={setSelectedIds}
            />
          ) : null}
        </>
      }
    >
      <Box>
        {/* STATUS FILTER */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          spacing={1}
          sx={{ mb: 2 }}
        >
          <ToggleButtonGroup
            size="small"
            exclusive
            value={statusFilter}
            onChange={handleStatusFilterChange}
            aria-label="verification status filter"
          >
            {STATUS_FILTERS.map((option) => (
              <ToggleButton key={option.id} value={option.id}>
                {option.label} ({counts[option.id]})
              </ToggleButton>
            ))}
          </ToggleButtonGroup>

          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Showing {filteredUsers.length} of {counts.all}
          </Typography>
        </Stack>

        <DataGrid
          components={{ Toolbar: CustomGridToolbar }}
          rows={filteredUsers}
          columns={TableHead}
          loading={loading}
          getRowId={(row) => row.userID}
          pageSize={gridSize}
          autoHeight
          rowsPerPageOptions={[5, 10, 25, 50]}
          onPageSizeChange={(newGridSize) => setGridSize(newGridSize)}
          onSelectionModelChange={(ids) => {
            setSelectedIds(ids);
          }}
          //v5 PROP NAME . IT WAS rowSelectionModel ( v6/v7 ) , WHICH THIS DATAGRID IGNORES ,
          //SO THE SELECTION WAS NEVER ACTUALLY CONTROLLED AND NEVER CLEARED
          selectionModel={selectedIds}
          checkboxSelection
          disableSelectionOnClick
          isRowSelectable={(params) =>
            params.row.transport_payment_verification == 0
          }
        />
      </Box>
    </GlobalWrapper>
  );
};

export default TransportVerification;
